// extracted by mini-css-extract-plugin
export var wrapper = "ModalAside-module--wrapper--3eafb";
export var collapsible = "ModalAside-module--collapsible--51a74";
export var title = "ModalAside-module--title--015ff";
export var section = "ModalAside-module--section--d9891";
export var sectionTitle = "ModalAside-module--sectionTitle--63fd0";
export var contacts = "ModalAside-module--contacts--5f53f";